import {
  benefitGlyph,
  decentralizedGlyph,
  highDemandGlyph,
  nftDevelopmentGlyph,
} from 'Assets/_Legacy/BlockchainPage'
import {
  decentralizeGlyph,
  giftGlyph,
  networkGlyph,
  peopleGlyph,
  searchGlyph,
  shoppingCartGlyph,
  storeGlyph,
  walletGlyph,
} from 'Assets/_Legacy/BlockchainPage/icons'
import {
  bitFinanceLogo,
  boredApeLogo,
  creatorLogo,
  networkOsLogo,
  sappChatLogo,
  whaleRoomLogo,
  workAxleLogo,
} from 'Assets/Image/CompanyLogos/Small'

import { PROJECT } from 'Constants/Paths'
import { ProjectId } from 'Constants/Projects/types'

export const DAPPS_DEVELOPMENT_GLYPHS = [decentralizedGlyph, benefitGlyph]
export const DAPPS_PROVIDE_CARDS_DATA = [
  {
    id: 'card_01',
    glyph: networkGlyph,
    sub: [
      {
        projectId: '24288616',
        subText: 'CreatorAI',
        subImage: creatorLogo,
        subLink: PROJECT(ProjectId.Creator),
      },
    ],
  },
  {
    id: 'card_02',
    glyph: giftGlyph,
    sub: [
      {
        projectId: '22415034',
        subText: 'WorkAxle',
        subImage: workAxleLogo,
        subLink: 'workaxle',
      },
      {
        projectId: '24220186',
        subText: 'NetworkOS',
        subImage: networkOsLogo,
        subLink: 'networkos',
      },
    ],
  },
  {
    id: 'card_03',
    glyph: walletGlyph,
    sub: [
      {
        projectId: '87642379',
        subText: 'SappChat',
        subImage: sappChatLogo,
        subLink: 'sappchat',
      },
    ],
  },
  {
    id: 'card_04',
    glyph: peopleGlyph,
    sub: [
      {
        projectId: '51628899',
        subText: 'WhaleRoom',
        subImage: whaleRoomLogo,
        subLink: 'whaleroom',
      },
    ],
  },
  {
    id: 'card_05',
    glyph: decentralizeGlyph,
    sub: [
      {
        projectId: '87642379',
        subText: 'SappChat',
        subImage: sappChatLogo,
        subLink: 'sappchat',
      },
      {
        projectId: '24220177',
        subText: 'BitFinance',
        subImage: bitFinanceLogo,
        subLink: 'bitfinance',
      },
    ],
  },
  {
    id: 'card_06',
    glyph: searchGlyph,
    sub: [
      {
        projectId: null,
      },
    ],
  },
]

export const NFT_DEVELOPMENT_GLYPHS = [highDemandGlyph, nftDevelopmentGlyph]
export const NFT_PROVIDE_CARDS_DATA = [
  {
    glyph: shoppingCartGlyph,
    sub: [
      {
        projectId: 'undefined_001',
        subText: 'Bored Ape Yacht Club',
        subImage: boredApeLogo,
      },
    ],
  },
  {
    glyph: storeGlyph,
    sub: [
      {
        projectId: '87642379',
        subText: 'SappChat',
        subImage: sappChatLogo,
        subLink: 'sappchat',
      },
    ],
  },
]
